import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  VStack,
  Heading,
  Text,
  Button,
  useToast,
  Grid,
  GridItem,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  SimpleGrid,
  Divider,
} from '@chakra-ui/react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const API_URL = API_BASE_URL;

function Home() {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/topics`);
        setTopics(response.data);
      } catch (error) {
        console.error('Error fetching topics:', error);
        toast({
          title: 'Error',
          description: 'Failed to fetch topics',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchTopics();
  }, [toast]);

  if (loading) {
    return <Text>Loading topics...</Text>;
  }

  return (
    <Box p={4}>
      <VStack spacing={6} align="stretch">
        <Heading mb={4}>IT Project Management Course</Heading>
        
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
          {topics.map((week) => (
            <GridItem key={week.week}>
              <Card height="100%" variant="outline">
                <CardHeader bg="blue.50" borderBottom="1px" borderColor="gray.200">
                  <Heading size="md">Week {week.week}</Heading>
                  <Text color="gray.600" fontSize="sm">{week.topic}</Text>
                </CardHeader>
                <CardBody>
                  <VStack align="stretch" spacing={3}>
                    {week.subtopics.map((subtopic) => (
                      <Button
                        key={subtopic.id}
                        variant="outline"
                        colorScheme="blue"
                        size="md"
                        height="auto"
                        whiteSpace="normal"
                        textAlign="left"
                        p={3}
                        onClick={() => navigate(`/topic/${week.week}/${subtopic.id}`)}
                        _hover={{
                          bg: 'blue.50',
                          transform: 'translateY(-2px)',
                          boxShadow: 'md',
                        }}
                        transition="all 0.2s"
                      >
                        <VStack align="start" spacing={1}>
                          <Text fontWeight="bold">{subtopic.title}</Text>
                          <Text fontSize="sm" color="gray.600" noOfLines={2}>
                            {subtopic.learning_objectives[0]}
                          </Text>
                        </VStack>
                      </Button>
                    ))}
                  </VStack>
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </SimpleGrid>
      </VStack>
    </Box>
  );
}

export default Home; 